var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", { attrs: { for: "supported-payment-methods" } }, [
          _vm._v("Supported Payment Methods"),
        ]),
        _c("br"),
        _vm._m(0),
        _c("v-select", {
          staticClass: "mt-3",
          attrs: {
            value: _vm.payLink.supportedPaymentMethods,
            options: _vm.PAYMENT_METHOD_OPTIONS,
            "get-option-label": function (option) {
              return option.label
            },
            "get-option-value": function (option) {
              return option.value
            },
            reduce: function (option) {
              return option.value
            },
            multiple: "",
          },
          on: { input: _vm.onChangeSupportedPaymentMethods },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("CustomSwitch", {
          attrs: {
            label: "Allow users to enter card security details",
            "helper-text":
              "Prompts users to enter required card details (e.g., CVV) if missing from their selected payment method.",
            value: _vm.payLink.userPatchedCards.enabled,
          },
          on: { input: _vm.onChangeUserPatchedCardsEnabled },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("CustomSwitch", {
          attrs: {
            label: "Allow users to add cards",
            "helper-text":
              "Card details are encrypted and stored securely for 24 hours.",
            value: _vm.payLink.userProvidedCards.enabled,
          },
          on: { input: _vm.onChangeUserProvidedCardsEnabled },
        }),
      ],
      1
    ),
    _vm.payLink.userProvidedCards.enabled
      ? _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Approved BIN Codes")]),
          _c("br"),
          _c("small", { staticClass: "text-muted" }, [
            _vm._v(
              ' Only allow users to add cards with the following BIN codes. Enter as comma-separated list of 6 or 8 digit codes (e.g., "123456, 567890").'
            ),
          ]),
          _c("input", {
            staticClass: "form-control mt-3",
            attrs: {
              placeholder: "123456, 567890",
              type: "text",
              pattern: _vm.binCodesPattern,
            },
            domProps: {
              value: _vm.payLink.userProvidedCards.binCodes.join(", "),
            },
            on: { change: _vm.onChangeBinCodes },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", { staticClass: "text-muted" }, [
      _vm._v(
        "Controls which of the user's payment methods can be used for payment switching. If not set, all saved payment methods will be available. This setting is relevant for customers using multiple products (e.g., Deposit and Switch), whose users have bank accounts "
      ),
      _c("em", [_vm._v("and")]),
      _vm._v(" cards in Atomic's system."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }